import { S as p } from "./chunk-SwiperElement-DayZ6j1H.js";
import { t as l } from "./chunk-custom-element-ttkHUa8w.js";
import "./chunk-lit-element-CNHURX5C.js";
var u = Object.defineProperty, v = Object.getOwnPropertyDescriptor, d = (e, t, s, r) => {
  for (var i = r > 1 ? void 0 : r ? v(t, s) : t, n = e.length - 1, a; n >= 0; n--)
    (a = e[n]) && (i = (r ? a(t, s, i) : a(i)) || i);
  return r && i && u(t, s, i), i;
};
let o = class extends p {
  constructor() {
    super(...arguments), this.swiperOptions = {
      on: {
        afterInit: (e) => {
          this.updateNavigationVisibility(e), window.addEventListener("resize", this.debouncedResize(e));
        }
      }
    }, this.debouncedResize = (e) => {
      let t;
      return () => {
        clearTimeout(t), t = setTimeout(() => {
          this.updateNavigationVisibility(e);
        }, 200);
      };
    };
  }
  updateNavigationVisibility(e) {
    setTimeout(() => {
      const t = e.navigation.nextEl, s = e.navigation.prevEl, r = t == null ? void 0 : t.parentElement;
      if (t && s && r) {
        const i = t.getAttribute("aria-disabled") === "true", n = s.getAttribute("aria-disabled") === "true";
        r.style.display = i && n ? "none" : "";
      }
    }, 100);
  }
};
o = d([
  l("swiper-with-nav")
], o);
export {
  o as SwiperWithNav
};
